import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { API_UPDATE_PROFESSIONAL_SOLUTION_ORDER_CONSIDERATION, API_UPDATE_PROFESSIONAL_SOLUTION_ORDER_ORDER, apiUpdateProfessionalSolutionOrderConsideration, apiUpdateProfessionalSolutionOrderOrder, } from '../../../../../actions/ProfessionalMySolutionActions';
import { getFullName } from '../../../../../helpers/auth';
import { getViewYmd } from '../../../../../helpers/common';
import { propBool, propFunc, propShape, } from '../../../../../helpers/custom-prop-types';
import { isLoadingApis } from '../../../../../helpers/fetch';
import { textPrice } from '../../../../../helpers/solution';
import { userOrganizationName } from '../../../../../helpers/user';
import SubmitButton from '../../../../Ui/Button/SubmitButton';
import Image from '../../../../Ui/Common/Image';
import ShowModal from '../../../../Ui/Modal/ShowModal';
import FormConfirmOrder from '../Form/FormConfirmOrder';
class ModalProposalAlert extends Component {
    constructor(props) {
        super(props);
        this.considerLater = () => {
            const { considerLater, order } = this.props;
            considerLater(order);
        };
        this.considerOrder = () => {
            this.setState({
                showConsider: false,
            });
        };
        this.considerOrderCancel = () => {
            this.setState({
                showConsider: true,
            });
        };
        this.considerOrderSubmit = (values) => {
            const { considerOrder, order } = this.props;
            considerOrder(order, values);
        };
        this.state = {
            showConsider: true,
        };
    }
    render() {
        const { isLaterLoading, isLoading, isOrderLoading, order, orderForm, solution, } = this.props;
        const middleClass = solution.solutionMiddleClass;
        const { showConsider } = this.state;
        if (showConsider) {
            return (_jsx(ShowModal, Object.assign({ isShow: true }, { children: _jsxs("div", Object.assign({ className: 'modal-content' }, { children: [_jsx("div", Object.assign({ className: 'modal-header' }, { children: _jsx("h3", Object.assign({ className: 'font-warning' }, { children: "\u672A\u5165\u529B\u306E\u6848\u4EF6\u304C\u3042\u308A\u307E\u3059" })) })), _jsxs("div", Object.assign({ className: 'modal-main' }, { children: [_jsxs("div", Object.assign({ className: 'solution-overview' }, { children: [_jsx("div", Object.assign({ className: 'image' }, { children: _jsx(Image, { alt: solution.title, src: solution.thumbnail }) })), _jsxs("div", Object.assign({ className: 'title' }, { children: [_jsx("h4", { children: solution.title }), _jsxs("span", Object.assign({ className: 'font-size-0-8rem' }, { children: [middleClass && `${middleClass.name} / `, textPrice(solution.price)] }))] }))] })), _jsxs("div", Object.assign({ className: 'client-message' }, { children: [_jsx("span", Object.assign({ className: 'font-size-0-8rem' }, { children: userOrganizationName(order.client) })), _jsx("h3", { children: `${getFullName(order.client)} 様` }), _jsxs("div", Object.assign({ className: 'modal-main-scroll' }, { children: [_jsx("time", { children: getViewYmd(order.createdAt) }), _jsx("div", Object.assign({ className: 'message-inner' }, { children: order.inquiry && order.inquiry.content }))] }))] }))] })), _jsx("div", Object.assign({ className: 'align-center modal-footer' }, { children: _jsxs("ul", Object.assign({ className: 'action' }, { children: [_jsx("li", { children: _jsx(SubmitButton, { buttonType: 'button', className: 'btn btn-primary orange', isDisabled: isLoading, isLoading: isLaterLoading, onClick: this.considerLater, text: '検討中' }) }), _jsx("li", { children: _jsx(SubmitButton, { buttonType: 'button', className: 'btn btn-primary', isDisabled: isLoading, isLoading: isOrderLoading, onClick: this.considerOrder, text: '受注する' }) })] })) }))] })) })));
        }
        return (_jsx(ShowModal, Object.assign({ isShow: true }, { children: _jsx(FormConfirmOrder, { hideModal: this.considerOrderCancel, isLoadingApi: isLoading, onSubmit: this.considerOrderSubmit, solutionPrice: (solution && solution.price) || 300, thisForm: orderForm }) })));
    }
}
ModalProposalAlert.propTypes = {
    considerLater: propFunc().isRequired,
    considerOrder: propFunc().isRequired,
    isLaterLoading: propBool().isRequired,
    isLoading: propBool().isRequired,
    isOrderLoading: propBool().isRequired,
    order: propShape().isRequired,
    orderForm: propShape(),
    solution: propShape().isRequired,
};
ModalProposalAlert.defaultProps = {
    orderForm: {},
};
const mapStateToProps = ({ fetch, form }) => {
    const isOrderLoading = isLoadingApis(fetch, API_UPDATE_PROFESSIONAL_SOLUTION_ORDER_ORDER);
    const isLaterLoading = isLoadingApis(fetch, API_UPDATE_PROFESSIONAL_SOLUTION_ORDER_CONSIDERATION);
    return {
        isLaterLoading,
        isLoading: isLaterLoading || isOrderLoading,
        isOrderLoading,
        orderForm: form && form.FormConfirmOrder,
    };
};
const mapDispatchToProps = (dispatch) => ({
    considerLater: (order) => {
        // 再検討の実施
        dispatch(apiUpdateProfessionalSolutionOrderConsideration(order.id));
    },
    considerOrder: (order, values) => {
        // 受注の実行
        dispatch(apiUpdateProfessionalSolutionOrderOrder(order.id, values));
    },
});
const enhance = compose(connect(mapStateToProps, mapDispatchToProps));
export default enhance(ModalProposalAlert);
